import React from 'react';
import { useNavigate } from 'react-router-dom';

import './Container.css';
import image1 from '../../asserts/images/bgstudent.jpeg'
import image2 from '../../asserts/images/isimm3.jpg';
import image3 from '../../asserts/images/isimm4.jpg';
import image0 from '../../asserts/images/isimm7.jpg';
import Filieres from './Filieres';

import student from '../../asserts/images/student.png';
import teacher from '../../asserts/images/teacher.png';
import graduation from '../../asserts/images/graduation.png';
import Counter from './Counter';
import Box from './VieAssociative';
import Actualites from './Actualites';
import Contact from './Contact';
import Dalel from '../Dalel';


function Container() {
  const slides = [
    { url: image1, title: 'image0' },
    { url: image0, title: 'image1' },
    { url: image2, title: 'image2' },
    { url: image3, title: 'image3' },

  ];

  const containerStyles = {
    width: '100%',
    height: '85vh',
    backgroundColor:'#FCFCFC'
  };

  const navigate = useNavigate();

  const handleClickMastere = () => {
    navigate('/Mastère');
  };

  const handleClickIng = () => {
    navigate('/Ingenieurie');
  };

  return (
    <>

    <div className='imagesAccaeuil' >
      <Dalel/>
      <div className='b'>
         <p className='name' >L'Institut Supérieur</p> <p className='name'>D'Informatique et de  </p><p className='name'> Mathématiques De Monastir</p>
      </div>

    </div>

    <div className='Bienvenu'>
      <button className='btnMastere btnbienvenu' onClick={handleClickMastere}>Mastère<i class="fa-solid fa-angle-right"></i></button>
      <button className='btnIng btnbienvenu' onClick={handleClickIng}>Cycle d'ingénieure<i class="fa-solid fa-angle-right"></i></button>

    </div>
                    <Actualites/>
                 
                  <div className='VieAssociative' style={{backgroundColor: '#E7E7E7',minHeight:'85vh' ,paddingBottom:'100px',paddingTop:'10px',marginBottom:'0px' , position :'relative'}}>
                    <div >
                    
                        <h5 style={{color:'orange',paddingLeft:'0px',fontSize:'16px' , paddingTop:'15px', textAlign: 'center'}}>  UNE VIE ASSOCIATIVE RICHE AU CŒUR DE L'INSTITUT</h5>
                        <h1 className="container-fluid text-center">Un merveilleux endroit pour vivre, étudier et travailler</h1>
                        <h3 className="container-fluid text-center">ISIMM vous offre une vie culturelle très animée<br/>
                            une multitude de clubs et une approche orientée vers l'international</h3>
                            <br/>
                    </div>
        
                    <div style={{marginLeft:'4.5%',marginRight:'70px' , position:'relative'}}>

                        <Box/>
                    </div>
                  </div>


                  <div style={{marginTop : '0px' , width:"100%", height:'85vh' ,    backgroundColor: '#FCFCFC' , position :'relative'}}>
                    <Filieres/>
                  </div>

                  <div style={{ backgroundColor: ' #E7E7E7 ', minHeight: '80vh', paddingTop: '5px' , position:'relative'}}>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                        <div style={{ paddingTop: '20px' }}>
                            <h4 id='titrecompteur'className="container-fluid text-center">Depuis 2002 jusqu’à maintenant, découvrez</h4>
                            <h1 className="container-fluid text-center">L'ISIMM EN CHIFFRE </h1>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', paddingLeft: '150px',paddingRight: '150px',paddingTop:'50px' ,flexWrap:'wrap',flexDirection:'row',columnGap: '10px',rowGap: '10px'}}>
                        <Counter title="ETUDIANT" initialValue={0} stopValue={500} imageSrc={student} />
                        <Counter title="ENSEIGNANT" initialValue={0} stopValue={100} imageSrc={teacher} />
                        <Counter title="DIPLOME" initialValue={0} stopValue={400} imageSrc={graduation} />
                    </div>
                  </div>
               
              

              

                  <div className='contact' > 
                    <Contact/> 
                  </div>


    </>
    
  );
}

export default Container;
